import { Link } from 'react-router-dom';
import { genres } from '@/mocks/genres';
import SectionHeading from '@/components/base/SectionHeading';

export default function GenreGrid() {
  return (
    <section className="w-full px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        title="按类型速览"
        subtitle="从类型出发，快速找到你感兴趣的那一类影片"
      />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-8">
        {genres.map((genre) => (
          <Link
            key={genre.key}
            to={`/movies/category/${genre.key}`}
            className="group flex flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-3 py-6 transition-colors hover:border-accent-300 hover:bg-accent-50"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100 text-2xl text-secondary-700 transition-colors group-hover:bg-accent-100 group-hover:text-accent-700">
              <i className={genre.icon} />
            </span>
            <span className="text-sm font-medium text-foreground-800 group-hover:text-accent-700">
              {genre.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}